import { cn } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';
import { renderItemType } from 'components/practice/BeyondBilling/ElectronicInvoicing/lib/renderType';

const ServiceDetails = ({ service }) => {
  const { device } = useUIContext();
  const isMobile = device === 'mobile' || device === 'tablet-sm';

  return (
    <div className={cn('flex w-full flex-col gap-2.5', isMobile && '-mb-4')}>
      {service?.name && (
        <Typography variant="label" size="medium" weight="medium">
          {service?.name}
        </Typography>
      )}
      <div className="flex items-center gap-2">
        {service?.procedure_code && (
          <Typography variant="p" size="xs" color="neutral-700">
            CPT® code: {service?.procedure_code}
          </Typography>
        )}
        {service?.procedure_code && (
          <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
        )}
        <Typography variant="p" size="xs" color="neutral-700">
          {renderItemType(service)}
        </Typography>
      </div>
    </div>
  );
};

export default ServiceDetails;
